Object.defineProperty(exports, '__esModule', { value: true });

var components_baseOption_Component = require('./Component.js');
require('tslib');
require('react');
require('classnames');
require('../base-checkmark/Component.js');
require('../../../checkbox');
require('@alfalab/icons-glyph/CheckmarkMIcon');



exports.BaseOption = components_baseOption_Component.BaseOption;
